<template>
  <div class="rule-wrapper">
    <div class="row">
      <div class="col">
        <template v-for="(rule, i) in rules">
          <template v-if="isRule(rule)">
            <edit-conditional-rule :rule="rule"
                                   :rule-set="ruleSet"
                                   :isFirstRule="i === 0"
                                   :parent="parent"
                                   :key="rule.client_id"
                                   :index="i"
                                   v-bind="conditionalRuleOptions"
                                   :outside-modal="outsideModal"
                                   :matchFormFields="matchFormFields"
            >
              <template #rule-options="slotProps" ><slot name="rule-options" :rule="slotProps.rule"></slot></template>
            </edit-conditional-rule>
          </template>
          <template v-else>
            <div class="row">
              <div class="col-1 head">
                <template v-if="i === 0">
                  <strong>If</strong>
                </template>
                <template v-else>
                  <and-or-select v-model="ruleSet.join_type" :outside-modal="outsideModal"></and-or-select>
                </template>
              </div>
              <div class="col">
                <edit-conditional-rule-set :rule-set="rule"
                                           :isFirstRule="i === 0"
                                           :key="rule.client_id"
                                           :parent="parent"
                                           :conditional-rule-options="conditionalRuleOptions"
                                           :outside-modal="outsideModal"
                                           :match-form-fields="matchFormFields"
                >
                  <template #rule-options="slotProps" ><slot name="rule-options" :rule="slotProps.rule"></slot></template>
                </edit-conditional-rule-set>
              </div>
            </div>
          </template>
        </template>
      </div>
      <div class="col-1 suffix" v-if="canControl && !disallowMultipleConditions">
        <rule-options :model="ruleSet"></rule-options>
      </div>
    </div>
    <div class="add-control" v-if="!disallowMultipleConditions">
      <div class="dropdown">
        <button data-toggle="dropdown"
                @click="teleport.dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                class="dropdown-toggle btn-icon grey-to-blue add-rule">
          <span class="sr-only">Add Rule Dropdown</span>
          <span class="icon-text plus"></span>
        </button>
        <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="ruleSetMoreOptions">
          <li>
            <button class="dropdown-item" @click="addRule">+ Add Condition</button>
            <button v-if="allowMultipleSets" class="dropdown-item" @click="addRuleSet">+ Add AND/OR group</button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";

  import EditConditionalRule from "./editConditionalRule.vue"
  import AndOrSelect from "./vSelects/andOrSelect.vue";
  import RuleOptions from "./ruleOptions.vue"
  import {teleport} from '~/modules/nodeManager';
  import ConditionalRuleSet from "../../models/conditionalRules/conditionalRuleSet";
  import ConditionalRule from "../../models/conditionalRules/conditionalRule";
  import IConditionalRuleContainer from "../../models/conditionalRules/conditionalRuleContainer";
  import {IConditionalRuleOptions} from "~/interfaces/modeling/conditionalRuleInterfaces";
  import {BooleanHelper} from "~/helpers/booleanHelper";

  export default Vue.extend({
    name: 'edit-conditional-rule-set',
    props: {
      ruleSet: Object as () => ConditionalRuleSet,
      parent: Object as () => IConditionalRuleContainer,
      isFirstRule: Boolean,
      conditionalRuleOptions: {
        type: Object as () => IConditionalRuleOptions,
        default: () => ({})
      },
      outsideModal: {
        type: Boolean,
        default: false,
      },
      matchFormFields: {
        type: Boolean,
        default: false
      },
      disallowMultipleSets: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      EditConditionalRule,
      AndOrSelect,
      RuleOptions
    },
    data() {
      return {
        teleport: teleport
      };
    },
    computed: {
      rules(): ConditionalRule[] {
        return Object.keys(this.ruleSet.conditional_rules).map(key => this.ruleSet.conditional_rules[key])
          .sort((a, b) => a.sort_order - b.sort_order);
      },
      incompleteRules(): ConditionalRule[] {
        return this.rules.filter(r => {
          if (r.referencedControl && !r.referencedControl.isValidForConditionalLogic) return true;
          return !r.value;
        });
      },
      modifiedRules(): ConditionalRule[] {
        return this.rules.filter(r => r.hasChanged);
      },
      isComplete(): boolean {
        return this.incompleteRules.length === 0;
      },
      hasNoChanges(): boolean {
        return this.modifiedRules.length === 0;
      },
      canControl(): boolean {
        return this.ruleSet.parent instanceof ConditionalRuleSet;
      },
      disallowMultipleConditions(): boolean {
        return this.conditionalRuleOptions.disallowMultipleConditions === true
      },
      allowMultipleSets(): boolean {
        return BooleanHelper.isStrictFalse(this.disallowMultipleSets);
      },
    },
    methods: {
      addRule(): void {
        this.ruleSet.addNewRule(false);
      },
      addRuleSet(): void {
        this.ruleSet.addNewRuleSet(false);
      },
      isRule(rule) {
        return rule instanceof ConditionalRule;
      },
    }
  });
</script>
